<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-5">
          <fieldset style="height: 79vh">
            <div class="d-flex justify-content-between">
              <legend class="text-black">
                {{ $t('studentScoringEntry.scoreEntry') }}
              </legend>
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 300px"
              />
            </div>
            <div
              class="overflow-auto"
              style="max-height: 73vh"
              v-if="isNotIgnoreByScoringCycle"
            >
              <table class="table table-bordered">
                <thead class="ts-bg-gray-200">
                  <tr>
                    <th class="text-center" valign="middle" rowspan="2">
                      SUBJECTS
                    </th>
                    <th
                      class="ts-text-xs text-center"
                      :colspan="gradingDefiniton.length"
                    >
                      ACADEMIC ACHIEVEMENT
                    </th>
                  </tr>
                  <tr>
                    <th
                      class="ts-text-xs text-center"
                      v-for="(grading, index) in gradingDefiniton"
                      :key="index"
                    >
                      <span class="badge bg-info rounded-pill">{{
                        grading.grade
                      }}</span>
                      <br />
                      {{ grading.definition_name_en }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="(records, subject_name_foreign) in resources"
                  >
                    <tr style="background-color: #F9FBFB">
                      <td
                        style="padding: 11px 4px"
                        :colspan="gradingDefiniton.length + 1"
                        class="text-primary ts-font-bold"
                      >
                        {{ subject_name_foreign }}
                      </td>
                    </tr>
                    <tr v-for="(item, index) in records">
                      <td>
                        <span class="ts-text-xs">{{
                          item.comp_item_name
                        }}</span>
                      </td>
                      <td
                        v-for="(grading, indexColumn) in gradingDefiniton"
                        :key="indexColumn"
                        class="text-center"
                      >
                        <input
                          :id="index + '_grade_' + indexColumn"
                          type="radio"
                          v-model="item.grade"
                          :value="grading.grade"
                          :checked="item.grade === grading.grade ? true : false"
                          class="ts-cursor-pointer ts-text-lg"
                        />
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <div
              v-if="!isNotIgnoreByScoringCycle"
              class="text-center ts-justify-items-center"
            >
              Ignore entry score for scoring cycle:
              <span class="ts-font-bold text-primary">
                {{
                  scoringCycleSelected
                    ? scoringCycleSelected.scoring_cycle_name
                    : '-'
                }}
              </span>
            </div>
          </fieldset>
        </div>
        <div class="col-md-7 ts-space-y-2 ts-border-l-4">
          <div class="row">
            <div class="col-md-9 ts-space-y-2">
              <student-info-entry
                v-model="model"
                :class-operations="classOperations"
                :student-profiles="studentProfiles"
              />
            </div>
            <div class="col-md-3">
              <div class="col-md-12">
                <div id="cover-image">
                  <img
                    :src="require('@/assets/background-student-profile.png')"
                    alt
                    class="cover"
                  />
                  <div id="img-frame" class="text-center mb-1">
                    <img
                      v-lazy="{
                        src: studentProfiles.photo,
                        error: require('@/assets/user_default.png'),
                        loading: require('@/assets/Rolling-1s-200px_2.svg')
                      }"
                    />
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <div class="col-md-12 text-center">
                    <span>{{
                      studentProfiles ? studentProfiles.card_number : '-'
                    }}</span>
                    <h3
                      class="
                        text-center
                        ts-font-bold ts-text-sm
                        mt-2
                        mb-0
                        text-uppercase text-primary
                      "
                    >
                      {{ studentProfiles ? studentProfiles.full_name_en : '-' }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <fieldset style="height: 51.6vh">
              <legend class="text-black">
                {{ $t('studentScoringEntry.scoreRating') }}
              </legend>
              <div
                class="form-group m-b-10"
                v-if="this.model.scoring_cycle_id == 5"
              >
                <label class="col-form-label control-label required">
                  {{ $t('studentScoringEntry.unitTitle') }}
                </label>
                <div>
                  <input
                    class="form-control"
                    v-model="unit_title"
                    :class="{
                      'is-invalid': errors.has('unit_title')
                    }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('unit_title')">
                    {{ errors.first('unit_title') }}
                  </div>
                </div>
              </div>
              <learning-strands-rating
                v-model="dataInput.learning_strands_sc_subject_id_list"
                :model-data="model"
                :elective-subjects="electiveSubjects"
                :validate="errors"
                v-if="enableRating"
              />
              <div
                v-if="!enableRating"
                class="text-center ts-justify-items-center"
              >
                No enable rating score entry for scoring cycle:
                <span class="ts-font-bold text-primary">
                  {{
                    scoringCycleSelected
                      ? scoringCycleSelected.scoring_cycle_name
                      : '-'
                  }}
                </span>
              </div>
            </fieldset>
          </div>
        </div>
        <a-modal
          v-if="advisor_comment"
          v-model="advisor_comment"
          :zIndex="1020"
          :title="'Student Name : ' + studentProfiles.full_name_en"
          :maskClosable="false"
          width="950px"
          :footer="null"
        >
          <advisor-comment
            v-model="model"
            @closeModal="() => (advisor_comment = false)"
          />
        </a-modal>
        <a-modal
          v-if="grading_definition"
          v-model="grading_definition"
          :zIndex="1020"
          :title="'Grading Definition'"
          :maskClosable="false"
          width="900px"
          :footer="null"
        >
          <grading-definition
            v-model="model"
            :grading-definitions="gradingDefinitions"
          />
        </a-modal>
      </div>
    </ts-loading-banner>
    <div class="ant-modal-footer ts-bottom-0 ts-left-0 ts-fixed ts-w-full">
      <ts-button
        color="info"
        @click.prevent="() => (grading_definition = true)"
        >{{ $t('studentScoringEntry.gradingDefinition') }}</ts-button
      >
      <ts-button color="warning" @click.prevent="onAdvisorComment()">{{
        $t('studentScoringEntry.comment')
      }}</ts-button>
      <ts-button @click.prevent="$emit('closeModal')">{{
        $t('cancel')
      }}</ts-button>
      <ts-button
        color="primary"
        @click.prevent="onSave"
        :waiting="waiting"
        :disabled="waiting"
        >{{ $t('save') }}</ts-button
      >
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import LearningStrandsRating from './learning-strands-rating'
import StudentInfoEntry from './student-info-entry'
import AdvisorComment from './advisor-comment-with-entry.vue'
import GradingDefinition from './grading-definition.vue'
import { orderBy } from 'lodash'

export default {
  name: 'studentScoringEntryRating',
  props: [
    'value',
    'paramsGetComponent',
    'classOperations',
    'studentProfiles',
    'ignoreScoringOnCycle',
    'enableRatingOnCycle'
  ],
  components: {
    LearningStrandsRating,
    StudentInfoEntry,
    GradingDefinition,
    AdvisorComment
  },
  data() {
    return {
      waiting: false,
      loading: false,
      show_alert: false,
      advisor_comment: false,
      grading_definition: false,
      errors: new Errors(),
      scoreComponents: [],
      electiveSubjects: [],
      gradingDefinitions: [],
      model: {},
      dataInput: Object.assign({}, this.value, {
        sc_subject_id_list: [],
        learning_strands_sc_subject_id_list: []
      }),
      gradingDefiniton: [],
      unit_title: null,
      search: ''
    }
  },
  created() {
    this.model = this.value
    this.fetchData()
  },
  computed: {
    isNotIgnoreByScoringCycle() {
      return this.ignoreScoringOnCycle.length > 0
        ? !this.ignoreScoringOnCycle.includes(this.model.scoring_cycle_id)
        : true
    },
    enableRating() {
      return this.enableRatingOnCycle.length > 0
        ? this.enableRatingOnCycle.includes(this.model.scoring_cycle_id)
        : false
    },
    scoringCycleSelected() {
      return this.$store.state.studentScoringEntry.scoring_cycles.find(
        c => c.scoring_cycle_id == this.model.scoring_cycle_id
      )
    },
    resources() {
      return this.groupBy(
        this.dataInput.sc_subject_id_list.filter(
          el =>
            el.subject_name_foreign
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) > -1 ||
            el.comp_item_name.toLowerCase().indexOf(this.search.toLowerCase()) >
              -1
        ),
        'subject_name_foreign'
      )
    }
  },
  methods: {
    ...mapActions('studentScoringEntry', [
      'getProgramStructure',
      'getGradingComponent',
      'store',
      'findScoring',
      'getAvgScoreBySubject'
    ]),
    onAdvisorComment() {
      this.advisor_comment = true
    },
    findScoringInput() {
      let {
        sc_item_subject_comp_list,
        sc_subject_id,
        st_class_id,
        ...params
      } = this.model
      return this.findScoring(params)
    },
    async fetchData() {
      this.loading = true
      let structure = await this.getProgramStructure({ ...this.model }).catch(
        error => {
          this.$toasted.error(error.message)
        }
      )
      await this.$store.dispatch('gradingDefinition/fetch', {
          filter: {
            acp_id: this.model.acp_id,
            acps_id: this.model.acps_id
          },
          page: -1
        })
        .then(response => {
          this.gradingDefinitions = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      this.fetchComment()
      await this.getGradingComponent({
        // get component by grade setup wheather item base or subject
        ...this.paramsGetComponent
      })
        .then(response => {
          this.scoreComponents = response.data
          this.electiveSubjects = response.electiveSubjects
          this.createInputData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.getGradingDefiniton()
        .then(response => {
          this.gradingDefiniton = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.findScoringInput()
        .then(response => {
          if (!_.isEmpty(response.data) || response.data.length > 0) {
            this.dataInput.sc_subject_id_list = this.scoreComponents.flatMap(subject =>
              orderBy(subject.component_items, ['display_order']).map(comp => {
                let score = response.data.find(
                  el => el.sc_subject_id == comp.subject_comp_id
                )
                return {
                  scoring_id: score ? score.scoring_id : 0,
                  sc_subject_id: comp.subject_comp_id,
                  comp_item_name: comp.comp_item_name,
                  subject_id: comp.subject_id,
                  subject_name_foreign: this.getComponentName(comp.subject_id),
                  grade: score ? score.grade : ''
                }
              })
            )
          }
          if (
            !_.isEmpty(response.learningStrands) ||
            response.learningStrands.length > 0
          ) {
            this.dataInput.learning_strands_sc_subject_id_list =
              response.learningStrands
            this.unit_title = response.learningStrands[0].unit_title
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    createInputData() {
      let {
        sc_item_subject_comp_list,
        sc_subject_id,
        st_class_id,
        ...excludeData
      } = this.model
      this.dataInput = Object.assign({}, excludeData, {
        sc_subject_id_list: this.isNotIgnoreByScoringCycle
          ? this.scoreComponents.flatMap(subject =>
              orderBy(subject.component_items, ['display_order']).map(comp => ({
                scoring_id: 0,
                sc_subject_id: comp.subject_comp_id,
                comp_item_name: comp.comp_item_name,
                subject_id: comp.subject_id,
                subject_name_foreign: this.getComponentName(comp.subject_id),
                grade: ''
              }))
            )
          : [],
        learning_strands_sc_subject_id_list: this.enableRating
          ? this.electiveSubjects.map(el => ({
              scoring_id: 0,
              sc_subject_id: el.subject_id,
              grade: null
            }))
          : [] //enable learning strands rating in grade
      })
    },
    getComponentName(sc_subject_id) {
      return this.scoreComponents
        .filter(c => c.id == sc_subject_id)
        .reduce((init, item) => (init = item.name), null)
    },
    isElectiveSubjectParent(sc_subject_id) {
      return this.scoreComponents
        .filter(c => c.id == sc_subject_id)
        .reduce((init, item) => (init = item.is_elective_subject_parent), null)
    },
    getGradingDefiniton() {
      return this.$store.dispatch('gradingDefinition/fetch', {
        fields: {
          score_grading_definitions: 'grade,definition_name_en'
        },
        filter: {
          acp_id: this.model.acp_id,
          acps_id: this.model.acps_id,
          definition_type: 'Rating'
        },
        page: -1
      })
    },
    onSave() {
      this.waiting = true
      this.errors = new Errors()
      this.store(
        Object.assign({}, this.dataInput, {
          sc_stu_com_id: this.model.sc_stu_com_id,
          advisor_id: this.model.advisor_id,
          comments: this.model.comments,
          suggesstion: this.model.suggesstion,
          unit_title: this.unit_title,
          st_class_id: this.value.st_class_id,
        })
      )
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('closeModal')
          this.model.sc_stu_com_id = 0
          this.model.advisor_id = null
          this.model.comments = null
          this.model.suggesstion = null
          this.model.unit_title = null
          this.$toasted.success('Action completed successfully!')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async getAvgScoreByParentSubject(item) {
      let result = await this.getAvgScoreBySubject({
        params: {
          student_id: this.model.student_id,
          subject_id: item.sc_subject_id,
          ac_term_id: this.model.ac_term_id,
          grade_id: this.paramsGetComponent.grade_id
        }
      }).catch(error => {
        this.$toasted.error(error.message)
      })
      item.grade = result.length > 0 ? parseInt(result[0].avg_score) : -1
    },
    fetchComment() {
      this.model.sc_stu_com_id = 0
      this.model.advisor_id = null
      this.model.comments = null
      this.model.suggesstion = null
      this.loading = true
      this.$store
        .dispatch('studentScoringEntry/findComment', {
          params: {
            student_id: this.value.student_id,
            st_class_id: this.value.st_class_id,
            scoring_cycle_id: this.value.scoring_cycle_id,
            cycle_value: this.value.cycle_value
          }
        })
        .then(response => {
          if (response.data) {
            this.model.sc_stu_com_id = response.data.sc_stu_com_id
            this.model.advisor_id = response.data.advisor_id
            this.model.comments = response.data.comments
            this.model.suggesstion = response.data.suggesstion
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    groupBy(array, key) {
      const result = {}
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
        }
        result[item[key]].push(item)
      })
      return result
    }
  }
}
</script>

<style lang="css" scoped>
table {
  width: 100%;
}
table > thead {
  border-bottom: 1px solid #d8d8d8;
  padding: 3px;
}
table > thead > tr > th {
  padding: 4px 7px;
}
table > tbody > tr > td {
  padding: 4px 7px;
}
.bb {
  border-bottom: 1px solid #d8d8d8;
  outline: none;
}
.cover {
  opacity: 0.2;
}
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.list-group-item {
  border: none !important;
  padding: 5px 0 5px 0;
  margin: 0;
  border-top: 1px solid #eee !important;
}
.list-group-item.address {
  border: none !important;
  padding-top: 2px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin: -51%;
}
#img-frame img {
  object-fit: contain;
  width: 15%;
  height: 15%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
label {
  display: block;
  margin-bottom: 0;
}

input[type='radio'] {
  appearance: none;
  background-color: #fff;
  width: 20px;
  height: 20px;
  border: 2px solid #ccc;
  border-radius: 2px;
  display: inline-grid;
  place-content: center;
}

input[type='radio']::before {
  content: '';
  width: 10px;
  height: 10px;
  transform: scale(0);
  transform-origin: bottom left;
  background-color: #fff;
  clip-path: polygon(13% 50%, 34% 66%, 81% 2%, 100% 18%, 39% 100%, 0 71%);
}

input[type='radio']:checked::before {
  transform: scale(1);
}
input[type='radio']:checked {
  background-color: #348fe2;
  border: 2px solid #348fe2;
}
fieldset {
  border: none;
  padding: 0 !important;
}
</style>
